import { Avatar } from '@material-ui/core';
import { getInfosDashboard } from '@webapps/business';
import { useQuery } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';

const AvatarCompany = ({
  height = 50,
  idCompany,
  name,
  variant = 'circular',
  width = 50,
  external = false,
  onFinish,
  toHtml,
  ...props
}) => {
  const { css } = useStyles();

  const { data: infos = {} } = useQuery(getInfosDashboard, {
    key: ['imageProfile', idCompany],
    variables: { id: idCompany },
    enabled: !external && !!idCompany,
    onSuccess: onFinish,
  });

  if (toHtml) {
    return infos?.profile?.profileImageUrl || idCompany?.profileImageUrl || idCompany?.logo ? (
      <img
        style={
          {
            height,
            width,
          }
        }
        src={infos?.profile?.profileImageUrl || idCompany?.profileImageUrl || idCompany?.logo}
        alt="company logo"
      />
    ) : (
      <div
        style={
          {
            height,
            width,
          }
        }
      >
        {name?.substr(0, 1)}
      </div>
    )
  }

  return infos?.profile?.profileImageUrl || idCompany?.profileImageUrl || idCompany?.logo ? (
    <Avatar
      className={css({
        height,
        width,
      })}
      src={infos?.profile?.profileImageUrl || idCompany?.profileImageUrl || idCompany?.logo}
      variant={variant}
      {...props}
    />
  ) : (
    <Avatar
      className={css({
        height,
        width,
      })}
      variant={variant}
      {...props}
    >
      {name?.substr(0, 1)}
    </Avatar>
  )
};

AvatarCompany.propTypes = {
  idCompany: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
  variant: PropTypes.string,
  name: PropTypes.string,
};

export default AvatarCompany;
